export enum ManagementPermissions {
  Management = 'management',
}
